import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { AlertColor } from "@mui/material/Alert";
import { ToastState } from "../../types";

interface CustomToastProps {
  open: string;
  severity: AlertColor | "";
  setToast: (value: ToastState) => void;
}

const CustomToast: React.FC<CustomToastProps> = ({
  open,
  severity,
  setToast,
}) => {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ): void => {
    if (reason === "clickaway") {
      return;
    }
    setToast({
      message: "",
      severity: "",
    });
  };

  return (
    <Snackbar
      open={!!open}
      autoHideDuration={5000}
      onClose={handleClose}
      sx={{ zIndex: "99999 !important" }}
      style={{ zIndex: "99999 !important" }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}>
      <Alert
        onClose={handleClose}
        severity={severity || "info"}
        variant="filled"
        sx={{ width: "100%" }}>
        {open || ""}
      </Alert>
    </Snackbar>
  );
};

export default CustomToast;
